<section>
  <div class="cert__tab-header">
    <div>
      <p class="cert__subheader-subtle">
        {{ "Cert.PageDescription3" | translate }}
        <a href="https://wiki.surfnet.nl/display/SURFcert/DNS+Firewall" target="_blank" rel="noopener noreferrer">
          https://wiki.surfnet.nl/display/SURFcert/DNS+Firewall
          <i class="external-link"></i>
        </a>
      </p>
    </div>
  </div>
  <div class="cert__filter-and-chart">
    <cert-filter-dns [prefixes]="prefixes()" (filtersChanged)="onFiltersChanged($event)"></cert-filter-dns>
    <div></div>
    <i class="cert__filter-divider">
      <span></span>
      <span></span>
      <span></span>
    </i>
    <cert-chart-generic
      [series]="dnsFirewallChartSeries()"
      [legendGroups]="dnsFirewallChartLegendGroups()"
      [loading]="loadingState()"
      [legendTitle]="'Cert.RPZFeed' | translate"
      [chartTitle]="''"
    ></cert-chart-generic>
  </div>
  <cert-dns-firewall-table
    [dnsFirewallLogs]="dnsFirewallLogs()"
    [pageInfo]="pageInfo()"
    (paginationChanged)="onPaginationChanged($event)"
    (sortingChanged)="onSortingChanged($event)"
    (pageSizeChanged)="onPageSizeChanged($event)"
  ></cert-dns-firewall-table>
</section>
